<template>
  <div id="app-sub-nav">
    <nav class="sub-nav">
      <ul class="sub-nav__list">
        <li class="sub-nav__list__item">
          <ReturnIcon />
        </li>
        <template v-for="{id, to, title, enabled, type} in routes">
          <li v-if="enabled"
              :key="id"
              class="sub-nav__list__item"
              :class="type"
          >
            <router-link :to="to">
              {{ title }}
            </router-link>
          </li>
        </template>
      </ul>
      <ArchiveFilterLetter v-if="isFilterAlphabet" color="white" />
      <BaseFilterFrequency v-if="isFilterFrequency" />
      <ArtistIndexList v-if="isFilterArtistIndex" :artist-type="getArtistType" />
    </nav>
  </div>
</template>

<script>
import ReturnIcon from "@/components/svg/ReturnIcon";
import ArchiveFilterLetter from "@/components/header/ArchiveFilterLetter.vue";
import BaseFilterFrequency from "@/components/ui/BaseFilterFrequency.vue";
import ArtistIndexList from "@/components/ui/ArtistIndexList.vue";

export default {
  name: "AppSubNav",
  components: {
    ArtistIndexList,
    BaseFilterFrequency,
    ArchiveFilterLetter,
    ReturnIcon
  },
  props: {
    routes: {
      type: Array,
      required: true,
    }
  },
  activated() {
    this.$root.$el.classList.add('sub-nav-active');
  },
  deactivated() {
    this.$root.$el.classList.remove('sub-nav-active');
  },
  computed: {
    getArtistType() {
      return this.$route.meta.hasOwnProperty('artistType') ? this.$route.meta.artistType : 'Resident';
    },
    getCurrentRoute() {
      return this.routes.find(({routeName, children}) => {
        if (typeof children !== 'undefined') {
          return children.some(e => e === this.$route.name) || routeName === this.$route.name;
        } else {
          return routeName === this.$route.name
        }
      });
    },
    isFilterAlphabet() {
      return typeof this.getCurrentRoute !== 'undefined' ? this.getCurrentRoute.filters.alphabet : false;
    },
    isFilterFrequency() {
      return typeof this.getCurrentRoute !== 'undefined' ? this.getCurrentRoute.filters.frequency : false;
    },
    isFilterArtistIndex() {
      return typeof this.getCurrentRoute !== 'undefined' ? this.getCurrentRoute.filters.artistIndex : false;
    }
  },
}
</script>

<style scoped lang="scss">
@import "@/assets/sass/abstracts/_variables.scss";

div#app-sub-nav {
  height: 40px;
  background-color: $c_base;
  display: flex;
  align-items: center;
  position: fixed;
  top: 137px;
  width: 100%;
  z-index: 1000;
  @include media-breakpoint-up(xl) {
    top: 80px;
  }
}

.sub-nav {
  padding: 0 20px;
  @include font-12-md;
  display: flex;
  justify-content: space-between;
  width: 100%;

  &__list {
    padding: 0;
    margin: 0;
    list-style: none;
    display: flex;
    align-items: center;

    &__item {
      margin-right: 10px;

      &.location > a,
      &.artist > a,
      &.archive > a {
        &.router-link-active {
          color: $c_white;
        }
      }

      a {
        color: $c_sub_nav_text;
        text-transform: uppercase;

        &.router-link-exact-active {
          color: $c_white;
        }
      }
    }
  }

  #archive-filter-letter {
    @include media-breakpoint-down(lg) {
      display: none;
    }
    //margin-left: auto;
    //margin-right: 0;
    display: flex;
    align-items: center;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
  }
  #base-filter-frequency::v-deep {
    top: 84px;
    right: 50px;
    .button-filter {
      width: 32px;
      height: 32px;
      padding: 8px;
    }
    .button-list__inner {
        height: 32px;
    }
  }

  #artist-index-list::v-deep {
    .button-artist-list {
      top: 84px;
      width: 32px;
      height: 32px;
      padding: 8px;
      right: 10px;
      @include media-breakpoint-down(lg) {
        top:0;
        right: 0;
      }
    }
  }

  .button-artist-list {
    top: 80px;
  }
}
</style>
